import { __decorate, __metadata } from "tslib";
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsDefined, IsOptional, IsString, IsUrl, ValidateNested } from 'class-validator';
import { WebMerchantExposeGroup } from '../interface';
import { ReadFaviconDto } from './ReadFaviconDto';
import { ReadWebMerchantMetadataLoyaltyFlowDto } from './ReadWebMerchantMetadataLoyaltyFlowDto';
import { ReadWebMerchantMetadataRewardsScreenDto } from './ReadWebMerchantMetadataRewardsScreenDto';
import { ReadWebMerchantMetadataUnsubscribeMessageDto } from './ReadWebMerchantMetadataUnsubscribeMessageDto';
export class ReadWebMerchantMetadataDto {
}
__decorate([
    ApiProperty({ type: () => ReadFaviconDto }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsDefined({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadFaviconDto),
    __metadata("design:type", ReadFaviconDto)
], ReadWebMerchantMetadataDto.prototype, "favicon", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadWebMerchantMetadataDto.prototype, "gTag", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantMetadataRewardsScreenDto }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantMetadataRewardsScreenDto),
    __metadata("design:type", ReadWebMerchantMetadataRewardsScreenDto)
], ReadWebMerchantMetadataDto.prototype, "rewardsScreen", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantMetadataLoyaltyFlowDto }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantMetadataLoyaltyFlowDto),
    __metadata("design:type", ReadWebMerchantMetadataLoyaltyFlowDto)
], ReadWebMerchantMetadataDto.prototype, "loyaltyFlow", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    IsUrl({ require_protocol: true, require_host: true, require_valid_protocol: true }, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantMetadataDto.prototype, "additionalLogo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantMetadataUnsubscribeMessageDto }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    Type(() => ReadWebMerchantMetadataUnsubscribeMessageDto),
    __metadata("design:type", ReadWebMerchantMetadataUnsubscribeMessageDto)
], ReadWebMerchantMetadataDto.prototype, "unsubscribeMessage", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadWebMerchantMetadataDto.prototype, "isOptionalEmailInMobileAppOnly", void 0);
//# sourceMappingURL=ReadWebMerchantMetadataDto.js.map